/**
 * vue组件可以使用的js方法
 * this.zhiji.getProtocalType()
 */
import { requestByServiceName } from "../services/service.js";
import { genItemSearchHandler, getQueryString, dateFormat, padStartZero, getDayMilliseconds, getDate } from "./util.js";
import { dragStart } from "./dragSwitch.js";
import { STATIC_IMG_PATH } from "./constants.js";

let caches = {};

export default {
    install(Vue) {
        Vue.prototype.zhiji = {
            reloadPageWithNewUrl(url) {
                if (url.indexOf("http") === -1) {
                    url = this.getProtocalType() + url;
                }
                window.location.href = url;
            },
            getProtocalType() {
                return caches.protocolType || (caches.protocolType = document.location.protocol);
            },
            getQueryString(name) {
                return getQueryString(name);
            },
            requestByServiceName(seviceName, param) {
                return requestByServiceName(seviceName, param);
            },
            strTrim(str) {
                return str.replace(/(^\s*)|(\s*$)/g, "");
            },
            genItemSearchHandler(key) {
                return genItemSearchHandler(key);
            },
            dragStart(event, dragableCls, direct, dropCB) {
                dragStart(event, dragableCls, direct, dropCB);
            },
            staticPath() {
                return STATIC_IMG_PATH;
            },
            dateFormat(date, format) {
                return dateFormat(date, format);
            },
            getDate(startTime, num, format) {
                return getDate(startTime, num, format);
            },
            getDayMilliseconds(n) {
                return getDayMilliseconds(n);
            },
            padStartZero(str, len) {
                return padStartZero(str, len);
            },
            transDateSparetor(dateStr, sparetorBefore, sparetorNow) {
                return dateStr.replace(new RegExp(sparetorBefore, "g"), sparetorNow);
            },
            isClickOuter(event, wrapperCls) {
                let target = event.target;

                while (target != window.document.body && target) {
                    const cls = target && target.getAttribute("class");
                    if (cls && cls.indexOf(wrapperCls) !== -1) {
                        return false;
                    }
                    target = target.parentNode;
                }
                return true;
            },
            openNewTabs(name) {
                return window.open(`${window.location.origin}/index.html#${name}`, "_blank");
            },
            goQuestionEdit(that, questionId) {
                const pageGameId = that.$store.state.zhiji.gameState.gameId;
                const currentGameId = window.localStorage.getItem("gameId");
                if (pageGameId == currentGameId) {
                    const routeUrl = that.$router.resolve({
                        name: "questionlist",
                        query: {
                            questionId
                        }
                    });
                    window.open(routeUrl.href, "_blank");
                } else {
                    that.$message({
                        message: "缓存ID与当前业务不符，请刷新后重试。",
                        type: "warning"
                    });
                }
            }
        };
    }
};
